module.exports = __webpack_public_path__ + "img/245.8b2c0a4d.jpg";